import { setGlobal } from 'reactn';

setGlobal({
});
